module.exports = __webpack_public_path__ + "img/arrow-button-left-1.34876faa.svg";